// extracted by mini-css-extract-plugin
export default {"phoneText":"VerifyPhoneOTP__phoneText___tN29A","resendButton":"VerifyPhoneOTP__resendButton___l38gC","skeleton-loading":"VerifyPhoneOTP__skeleton-loading___CoySU"};